// src/utils/emailUtils.ts
export const openEmailFeedback = (recipient: string, businessName: string) => {
  const subject = "Customer Feedback";
  const body = `Business Name: ${businessName}\nMy Feedback:`;
  const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  window.open(mailtoLink, "_blank");
};
